module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('p', {
    staticClass: "text-center text-uppercase"
  }, [_c('strong', [_vm._v(_vm._s(_vm.organization) + " | " + _vm._s(_vm.version))])])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5d1895a8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d1895a8"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./application/views/commons/footer.vue
// module id = 385
// module chunks = 1